import { Program } from "@coral-xyz/anchor";
import { PROGRAM_ID } from "./constants";
import { heliumSubDaosResolvers } from "./resolvers";
export async function init(provider, programId = PROGRAM_ID, idl) {
    if (!idl) {
        idl = await Program.fetchIdl(programId, provider);
    }
    const program = new Program(idl, programId ?? PROGRAM_ID, provider, undefined, () => {
        return heliumSubDaosResolvers;
    });
    return program;
}
export * from "./constants";
export * from "./pdas";
export * from "./resolvers";
//# sourceMappingURL=index.js.map